export default __webpack_public_path__ + "static/media/whitecalendar.2b33cba2.svg";